// pages/UpdateShopPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { alertServerError, alertError } from "../../../helpers/alertError";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import { uploadService } from "@cabukaka/services";
import ShopForm from "../../../components/features/shops/ShopForm";
import { useAuth, useSectors, useShop, useToken } from "@cabukaka/hooks";
import useCustomParams from "../../../hooks/params/useCustomParams";

export default function UpdateShopPage() {
    const { id } = useCustomParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { sectors } = useSectors();
    const { shop: initialData, updateShop } = useShop({ id: id || "" })
    const { token } = useToken()
    const { user } = useAuth()

    const handleSubmit = async (data: any) => {
        setIsLoading(true);
        if (!token) {
            alertError("Veillez vous connecter")
            return
        }
        try {

            const logoUrl = data.logoFile ? await uploadService.upload(data.logoFile, token) : data.existingLogo;
            const coverUrl = data.coverFile ? await uploadService.upload(data.coverFile, token) : data.existingCover;


            const submitData = {
                name: data.name,
                description: data.description,
                phone: data.phone,
                sectorId: data.sectorId,
                open: data.open,
                deliveryTime: data.deliveryTime,
                badge: data.badge,
                location: data.location,
                logo: logoUrl,
                coverImage: coverUrl,
                id: id
            };

            if (user?.role === "admin" || user?.role === "shop") {
                await updateShop(submitData);

            } else {
                alertError("Vous n'êtes pas autorisé à créer une boutique");
                return;
            }
            navigate(-1);
        } catch (error: any) {
            alertServerError(error);
        } finally {
            setIsLoading(false);
        }
    };

    if (!initialData) {
        return (
            <PageLayout title="Modifier la boutique">
                <div className="flex justify-center py-20">Chargement...</div>
            </PageLayout>
        );
    }

    return (
        <PageLayout title="Modifier la boutique">
            <PageContainer>
                <ShopForm
                    initialData={initialData}
                    sectors={sectors}
                    onSubmit={handleSubmit}
                    isSubmitting={isLoading}
                />
            </PageContainer>
        </PageLayout>
    );
}